import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    getProcessButtons, isUndNullEmp, getLanguageObj, getResponse, handleResponseMessageAsync, settings, styles
} from '../../helpers/main';
import { PaymentInformationDetail } from '../../classess/paymentInformation/paymentInformationDetail';
import { Company } from '../../classess/company/company';
import { PaymentInformation } from '../../classess/paymentInformation/paymentInformation';
import { PaymentInformationDetailService } from '../../services/paymentInformation/PaymentInformationDetailService';

const currentMethod = 'PaymentInformationDetailAddEdit';

const { html, icons, images, labels, messages, } = settings;

export default function PaymentInformationDetailAddEdit({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        userRole: '',
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        companies: [],
        setCompanies: () => { },
        dtPaymentInformationDetailsId: '',
        dtPaymentInformationDetailsRowId: 0,
        paymentInformation: PaymentInformation?.class({}, false),
        setPaymentInformation: () => { },
        paymentInformationDetail: PaymentInformationDetail?.class({}, false),
        setPaymentInformationDetail: () => { },
    },
    setModalObj = () => { },
}) {
    //#region variables
    const isMount = useRef(false);
    const [setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: false, save: false, back: false });
    const [errors, setErros] = useState({
        company: '',
        name: '',
        accountNumber: '',
        accountType: '',
    })
    const [dataFormLength] = useState(PaymentInformationDetail.minMaxLength(false));
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            paymentInformation: {
                id: 'inputModalPaymentInformation',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            name: {
                id: 'inputModalName',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            accountNumber: {
                id: 'inputModalAccountNumber',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            accountType: {
                id: 'inputModalAccountType',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
        selects: {
            companyId: {
                id: 'selModalCompanyId',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            }
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            },
        },
    };
    //#endregion variables

    //#region methods
    //#region paymentinformationdetail
    const addPaymentInformationDetail = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'addPaymentInformationDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            //#region add
            response = await PaymentInformationDetailService.create({
                token: modalObj?.auth?.user?.token?.token,
                data: modalObj?.paymentInformationDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion add

            const modelPaymentInformationDetail = PaymentInformationDetail?.class(response?.result?.paymentInformationDetail || {}, false);

            //#region datatable add
            const company = Company?.getClass(modalObj?.companies.filter(({ id }) => id === modelPaymentInformationDetail?.companyId)[0] || {}, false);

            const dtData = [
                company?.name || '',
                company?.rif || '',
                company?.email || '',
                modelPaymentInformationDetail?.name || '',
                modelPaymentInformationDetail?.accountNumber || '',
                modelPaymentInformationDetail?.accountType || '',
                getProcessButtons({
                    id: modelPaymentInformationDetail.id,
                    description: modelPaymentInformationDetail.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: modalObj?.userRole === settings?.roles?.admin,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRole === settings?.roles?.admin,
                    showEdit: modalObj?.userRole === settings?.roles?.admin,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRole === settings?.roles?.admin,
                    processButtons: [],
                })?.result,
            ];

            modalObj?.$(`#${modalObj?.dtPaymentInformationDetailsId}`).DataTable().row.add(dtData)?.draw(true);
            //#endregion datatable add

            // setDefaultValue({ closeModal: true, subMethod: currentMethod });

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }

    const editPaymentInformationDetail = async ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editPaymentInformationDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            setProcess(prev => ({ ...prev, save: true }));

            //#region update data
            response = await PaymentInformationDetailService.update({
                token: modalObj?.auth?.user?.token?.token,
                id: modalObj?.paymentInformationDetail?.id,
                data: modalObj?.paymentInformationDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion update data

            const modelPaymentInformationDetail = PaymentInformationDetail?.class(response?.result?.paymentInformationDetail || {}, false);

            //#region datatable update
            const company = Company?.getClass(modalObj?.companies.filter(({ id }) => id === modelPaymentInformationDetail?.companyId)[0] || {}, false);

            const dtData = [
                company?.name || '',
                company?.rif || '',
                company?.email || '',
                modelPaymentInformationDetail?.name || '',
                modelPaymentInformationDetail?.accountNumber || '',
                modelPaymentInformationDetail?.accountType || '',
                getProcessButtons({
                    id: modelPaymentInformationDetail.id,
                    description: modelPaymentInformationDetail.name,
                    showDetails: false,
                    labelDetails: labels?.details[modalObj?.languageObj?.id],
                    enabledDetails: false,
                    showDelete: modalObj?.userRole === settings?.roles?.admin,
                    labelDelete: labels?.delete[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRole === settings?.roles?.admin,
                    showEdit: modalObj?.userRole === settings?.roles?.admin,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRole === settings?.roles?.admin,
                    processButtons: [],
                })?.result,
            ];

            modalObj?.$(`#${modalObj?.dtPaymentInformationDetailsId}`).DataTable().row(modalObj?.dtPaymentInformationDetailsRowId).data(dtData)?.draw(true);
            //#endregion datatable update

            // setDefaultValue({ closeModal: true, subMethod: currentMethod });

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false }));
            if (response?.isSuccess && !response?.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    setShowData,
                    showDataValue: response?.isSuccess,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id,
                });
            }
        }
    }
    //#endregion paymentinformationdetail

    //#region others
    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmp({ data: modalObj?.paymentInformationDetail, subMethod: currentMethod })?.result) {
                setErros(prev => ({
                    ...prev,
                    company: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                    name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                    accountNumber: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                    accountType: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: modalObj?.paymentInformationDetail?.companyId, subMethod: currentMethod })?.result ||
                modalObj?.paymentInformationDetail?.companyId <= 0) {
                setErros(prev => ({
                    ...prev,
                    company: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: modalObj?.paymentInformationDetail?.name, subMethod: currentMethod })?.result) {
                setErros(prev => ({
                    ...prev,
                    name: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: modalObj?.paymentInformationDetail?.accountNumber, subMethod: currentMethod })?.result) {
                setErros(prev => ({
                    ...prev,
                    accountNumber: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: modalObj?.paymentInformationDetail?.accountType, subMethod: currentMethod })?.result) {
                setErros(prev => ({
                    ...prev,
                    accountType: `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`,
                }));
                response.isWarning = true;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErros(prev => ({
                ...prev,
                company: '',
                name: '',
                accountNumber: '',
                accountType: '',
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt={labels?.paymentInformationDetail?.[modalObj?.languageObj?.id]} src={images?.icons?.paymentInformation} style={styles?.cardHeaderLogo} />
                    </div>
                    <div className='d-flex flex-column'>
                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.paymentInformation?.[modalObj?.languageObj?.id]} ({labels?.detail?.[modalObj?.languageObj?.id]})</h5>
                        <div className='mt-1'>
                            <span className={`badge badge-pill ${modalObj?.type === 0 ? html?.badges?.info : modalObj?.type === 1 ? html?.badges?.warning : html?.badges?.secondary} px-2 py-1 text-uppercase`} style={html?.badges?.micro}>
                                <i className={`${icons?.fasFa?.creditCard} mr-1`}></i> {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] : labels?.details?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    type='button'
                    className='close border-0 bg-transparent'
                    data-dismiss='modal'
                    aria-label='Close'
                    disabled={process?.save}
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: '', })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => modalObj?.type === 0 ?
                addPaymentInformationDetail({ e: e, subMethod: 'form - onSubmit' }) :
                editPaymentInformationDetail({ e: e, subMethod: 'form - onSubmit' })}>
                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ? (
                            <div className='row'>
                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.indentFasFa} /> {labels?.paymentInformation?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.paymentInformation?.id}
                                            className='form-control bg-light border-0 shadow-sm text-muted'
                                            style={{ borderRadius: '5px' }}
                                            value={modalObj?.paymentInformation?.name || ''}
                                            placeholder={labels?.paymentInformation?.[modalObj?.languageObj?.id]}
                                            readOnly
                                            title={labels?.paymentInformation?.[modalObj?.languageObj?.id]} />
                                    </div>
                                </div>

                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.building} /> {labels?.company?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <select id={controls?.selects?.companyId?.id}
                                            autoFocus
                                            className='custom-select bg-light border-0 shadow-sm'
                                            style={{ borderRadius: '5px' }}
                                            disabled={process?.save}
                                            value={modalObj?.paymentInformationDetail?.companyId || ''}
                                            onChange={(e) => setModalObj({ ...modalObj, paymentInformationDetail: { ...modalObj?.paymentInformationDetail, companyId: parseInt(e?.target?.value), } })}
                                            onFocus={() => setErros(prev => ({ ...prev, company: '' }))}
                                            placeholder={labels?.company?.[modalObj?.languageObj?.id]}
                                            title={labels?.company?.[modalObj?.languageObj?.id]}>
                                            <option key={`0`} value={0}>{messages?.selectCompany[modalObj?.languageObj?.id]}</option>
                                            {modalObj?.companies.map((company) => <option key={company.id} value={company.id}>{company.name}</option>)}
                                        </select>
                                        <div className='form-text text-danger small mt-1 animated fadeIn'>{parse(errors?.company)}</div>
                                    </div>
                                </div>

                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.name?.id}
                                            className='form-control bg-light border-0 shadow-sm'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.name}
                                            readOnly={process?.save}
                                            onChange={(e) => setModalObj({ ...modalObj, paymentInformationDetail: { ...modalObj?.paymentInformationDetail, name: e?.target?.value }, })}
                                            onFocus={() => setErros(prev => ({ ...prev, name: '' }))}
                                            value={modalObj?.paymentInformationDetail?.name || ''}
                                            placeholder={labels?.name?.[modalObj?.languageObj?.id]}
                                            title={labels?.name?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text text-danger small mt-1 animated fadeIn'>{parse(errors?.name)}</div>
                                    </div>
                                </div>

                                <div className='col-12 mb-3'>
                                    <div className='form-group'>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.sortNumericDown} /> {labels?.number?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.accountNumber?.id}
                                            className='form-control bg-light border-0 shadow-sm'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.accountNumber}
                                            readOnly={process?.save}
                                            onChange={(e) => setModalObj({ ...modalObj, paymentInformationDetail: { ...modalObj?.paymentInformationDetail, accountNumber: e?.target?.value }, })}
                                            onFocus={() => setErros(prev => ({ ...prev, accountNumber: '' }))}
                                            value={modalObj?.paymentInformationDetail?.accountNumber || ''}
                                            placeholder={labels?.number?.[modalObj?.languageObj?.id]}
                                            title={labels?.number?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text text-danger small mt-1 animated fadeIn'>{parse(errors?.accountNumber)}</div>
                                    </div>
                                </div>

                                <div className='col-12 mb-0'>
                                    <div className='form-group'>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.type?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <input id={controls?.inputs?.accountType?.id}
                                            className='form-control bg-light border-0 shadow-sm'
                                            style={{ borderRadius: '5px' }}
                                            maxLength={dataFormLength?.max?.accountType}
                                            readOnly={process?.save}
                                            onChange={(e) => setModalObj({ ...modalObj, paymentInformationDetail: { ...modalObj?.paymentInformationDetail, accountType: e?.target?.value }, })}
                                            onFocus={() => setErros(prev => ({ ...prev, accountType: '' }))}
                                            value={modalObj?.paymentInformationDetail?.accountType || ''}
                                            placeholder={labels?.type?.[modalObj?.languageObj?.id]}
                                            title={labels?.type?.[modalObj?.languageObj?.id]} />
                                        <div className='form-text text-danger small mt-1 animated fadeIn'>{parse(errors?.accountType)}</div>
                                    </div>
                                </div>
                            </div>
                        ) :
                            <div className='row'>
                                <div className='col-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-primary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.building} /> {labels?.company?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold text-dark d-block mt-1'>
                                            {modalObj?.companies?.find(({ id }) => id === modalObj?.paymentInformationDetail?.companyId)?.name || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-info shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.name?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold text-dark d-block mt-1'>
                                            {modalObj?.paymentInformationDetail?.name || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-success shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.sortNumericDown} /> {labels?.number?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold text-dark d-block mt-1'>
                                            {modalObj?.paymentInformationDetail?.accountNumber || '---'}
                                        </span>
                                    </div>
                                </div>
                                <div className='col-12 col-md-6 mb-4'>
                                    <div className='p-3 rounded bg-light border-left border-secondary shadow-sm h-100' style={{ borderLeftWidth: '5px' }}>
                                        <small className={html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.spellCheck} /> {labels?.type?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <span className='h6 mb-0 font-weight-bold text-dark d-block mt-1'>
                                            {modalObj?.paymentInformationDetail?.accountType || '---'}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer className='border-top-0 pb-4 px-4 bg-white'>
                    <div className='d-flex justify-content-center w-100' style={{ gap: '10px' }}>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            hidden={modalObj?.type === 2}
                            title={modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                            type='submit'>
                            {process?.save ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i id={controls?.icons?.save?.id} className={`${controls?.icons?.save?.defaultClass} mr-1`} />
                            )}
                            {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] : labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.defaultClass}
                            style={{ borderRadius: '5px' }}
                            disabled={process?.save}
                            title={labels?.close?.[modalObj?.languageObj?.id]}
                            type='button'
                            onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                            <i id={controls?.icons?.back?.id} className={`${controls?.icons?.back?.defaultClass} mr-1`} />
                            {labels?.back?.[modalObj?.languageObj?.id]}
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}